import { useIsFetching, useQueryClient } from '@tanstack/react-query'
import { useToasts } from './useToasts'

/**
 * Manual refresh — invalidates all polling queries (devices, sensors, weather)
 * so React Query refetches each immediately. Server-side caches are tiny and
 * device/sensor measurements aren't cached on the server, so a client refetch
 * is enough.
 *
 * Returns:
 *   - refresh(): trigger the refetch
 *   - isFetching: any of the queries currently in-flight (for spinner state)
 */
export function useRefresh() {
  const qc = useQueryClient()
  const isFetching = useIsFetching() > 0
  const { push } = useToasts()

  const refresh = async () => {
    await Promise.allSettled([
      qc.invalidateQueries({ queryKey: ['devices'] }),
      qc.invalidateQueries({ queryKey: ['sensors'] }),
      qc.invalidateQueries({ queryKey: ['weather'] }),
    ])
    push('success', 'Aggiornamento in corso')
  }

  return { refresh, isFetching }
}
